import api from "./api";

export default class apiPagamentoDireto {
  static postPaymentSolicitation = async (obj: any) => {
    const response = await api.post(`/PagamentoNovo`, obj);
    return response.data;
  };

  static getPaymentSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    valorInicio: number,
    valorFim: number,
    isDataPagamento: boolean
  ) => {
    const response = await api.get(
      `/PagamentoNovo?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}
      &dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}
      &Search=${Search}&valorInicio=${valorInicio}&ValorFim=${valorFim}&isDataPagamento=${isDataPagamento}`
    );
    return response;
  };

  static getPaymentPerId = async (idPayment: any) => {
    const response = await api.get(`/PagamentoNovo/${idPayment}`);
    return response.data;
  };

  static deletePaymentPerId = async (id: number, obj: any) => {
    const response = await api.post(`/PagamentoNovo/${id}/cancelar`, obj);
    return response.data;
  };

  static cancelarRemessaPagamento = async (id: number) => {
    const response = await api.delete(`/PagamentoNovo/${id}/remover-remessa`);
    return response.data;
  };

  static confirmPayment = async (
    id: number,
    code: string,
    valor: number,
  ) => {
    const form = {
      codigo: code,
      valor: valor,
    };
  
    const response = await api.post(`/PagamentoNovo/${id}/Confirmar`, form);
    return response.data;
  };
  

  static exportPaymentList = async (
    idStatus: any,
    idCliente: number,
    dataInicio: any,
    dataFim: any
  ) => {
    const response = await api.get(
      `/PagamentoNovo/exportacao/download?idStatus=${idStatus}&dataInicio=${dataInicio}
      &dataFim=${dataFim}&idCliente=${idCliente}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };
}
